var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "addEditForm" },
    [
      _c("div", { staticClass: "formTitle" }, [_vm._v("编辑轮播图")]),
      _vm._v(" "),
      _c(
        "el-form",
        { attrs: { "label-width": "120px", model: _vm.swiperInfo } },
        [
          _c(
            "el-row",
            { staticClass: "margin24 bannerBox" },
            [
              _c(
                "el-form-item",
                { attrs: { label: "标题：" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.swiperInfo.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.swiperInfo, "name", $$v)
                      },
                      expression: "swiperInfo.name",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "链接：" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.swiperInfo.linkUrl,
                      callback: function ($$v) {
                        _vm.$set(_vm.swiperInfo, "linkUrl", $$v)
                      },
                      expression: "swiperInfo.linkUrl",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "轮播图上传：" } },
                [_c("FileImg", { on: { successUpLoad: _vm.successUpLoad } })],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { staticClass: "submitBtn" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.submit },
                },
                [_vm._v("提交")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.isBack },
                },
                [_vm._v("返回")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }